export const availableColors = [
  { name: '01', color: '#FFFFFF' },
  { name: '02', color: '#F4F4F4' },
  { name: '03', color: '#DEDFDF' },
  { name: '04', color: '#FFFAF2' },
  { name: '05', color: '#FFFBE9' },
  { name: '06', color: '#F0EBE1' },
  { name: '07', color: '#F6EADE' },
  { name: '08', color: '#FFF4CB' },
  { name: '09', color: '#F5E3A9' },
  { name: '10', color: '#FCED7E' },
  { name: '11', color: '#FFDCB5' },
  { name: '12', color: '#DBC7A0' },
  { name: '13', color: '#E4CFC0' },
  { name: '14', color: '#FCECEB' },
  { name: '15', color: '#E8D6D5' },
  { name: '16', color: '#F9DDD9' },
  { name: '17', color: '#EDC5CB' },
  { name: '18', color: '#F9D9E7' },
  { name: '19', color: '#EFB6D1' },
  { name: '20', color: '#E57CB3' },
  { name: '21', color: '#D1C6E3' },
  { name: '22', color: '#947FC6' },
  { name: '23', color: '#F39FA9' },
  { name: '24', color: '#C98994' },
  { name: '25', color: '#D28C7F' },
  { name: '26', color: '#C0615A' },
  { name: '27', color: '#9E3E39' },
  { name: '28', color: '#7A0630' },
  { name: '29', color: '#CE2424' },
  { name: '30', color: '#B02D08' },
  { name: '31', color: '#D58F5B' },
  { name: '32', color: '#F5A06F' },
  { name: '33', color: '#E5763E' },
  { name: '34', color: '#889C99' },
  { name: '35', color: '#99AEB7' },
  { name: '36', color: '#ABBFBC' },
  { name: '37', color: '#C1CEB6' },
  { name: '38', color: '#AFD1A1' },
  { name: '39', color: '#6E8D5C' },
  { name: '40', color: '#879275' },
  { name: '41', color: '#A5B095' },
  { name: '42', color: '#4E6D5B' },
  { name: '43', color: '#0C5648' },
  { name: '44', color: '#1D3D34' },
  { name: '45', color: '#B9C7C8' },
  { name: '46', color: '#D6E3E8' },
  { name: '47', color: '#D4E0F1' },
  { name: '48', color: '#DDF0FA' },
  { name: '49', color: '#C9EAF2' },
  { name: '50', color: '#ACDCF4' },
  { name: '51', color: '#6EBDD3' },
  { name: '52', color: '#659CBD' },
  { name: '53', color: '#92B4D2' },
  { name: '54', color: '#62728E' },
  { name: '55', color: '#5482D1' },
  { name: '56', color: '#167CB5' },
  { name: '57', color: '#145189' },
  { name: '58', color: '#0D2074' },
  { name: '59', color: '#07224B' },
  { name: '60', color: '#3D3A3A' },
  { name: '61', color: '#1E1C20' },
];
